<template>
  <h1>Facility Issue Report Vue</h1>
</template>
